<script lang="ts">
  let {
    value,
  }: {
    value: unknown
  } = $props()

  const url = $derived(String(value ?? ''))
</script>

<a class="widget-url" href={url} target="_blank" rel="noreferrer">{url}</a>
